const ROLES = {
		ADMIN: 1,
		PROPIETARIO: 2,
		PROFESIONAL: 3,
		MAQUINA: 4,
		QC: 5,
		SAT: 6,
};
export default ROLES;
